import { Controller } from "@hotwired/stimulus"

// Polls the tracker scan status while the loading page is shown. When the
// scan completes it reveals a "see the results" button instead of reloading,
// so a visitor mid-typing their email address doesn't lose their input.
export default class extends Controller {
  static values = { url: String }
  static targets = ["ready", "pending"]

  connect() {
    this.timer = setInterval(() => this.check(), 3000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async check() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return
      const status = await response.json()
      if (status.complete) {
        clearInterval(this.timer)
        this.pendingTargets.forEach((el) => el.classList.add("hidden"))
        this.readyTargets.forEach((el) => el.classList.remove("hidden"))
      }
    } catch {
      // transient network error — keep polling
    }
  }
}
